import { useKrakenMutation } from '@/components/GraphQLClient';
import { updatePropertyTypeSchema } from '@/hooks/accounts/validations';

import UpdatePropertyType from './UpdatePropertyType.graphql';

export type UpdatePropertyTypeInput = {
  input: {
    propertyId: string;
    propertyType: 'DETACHED' | 'SEMI_DETACHED' | 'TERRACED' | 'FLAT';
  };
};

export const useUpdatePropertyType = () => {
  return useKrakenMutation({
    mutation: (_: UpdatePropertyTypeInput) => UpdatePropertyType,
    async validateFn(response) {
      return await updatePropertyTypeSchema.validate(response);
    },
  });
};
